<template>
  <div>
    <v-data-table :items="items" :headers="headers">
      <template v-slot:item.actions="{item}">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.dateTaken="{item}">{{item.dateTaken | dateFormat}}</template>
      <template v-slot:item.examType="{item}">
        <slot name="examType" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.skin="{item}">
        <slot name="skin" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.head="{item}">
        <slot name="head" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.head="{item}">
        <slot name="head" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.eyes="{item}">
        <slot name="eyes" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.mouth="{item}">
        <slot name="mouth" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.resp="{item}">
        <slot name="resp" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.heart="{item}">
        <slot name="heart" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.gastro="{item}">
        <slot name="gastro" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.urinary="{item}">
        <slot name="urinary" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.reprod="{item}">
        <slot name="reprod" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.skeletal="{item}">
        <slot name="skeletal" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.circul="{item}">
        <slot name="circul" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.infectD="{item}">
        <slot name="infectD" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.dieasNV="{item}">
        <slot name="dieasNV" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.dieasTHHot="{item}">
        <slot name="dieasTHHot" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.dieasTHCold="{item}">
        <slot name="dieasTHCold" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.dieasPA="{item}">
        <slot name="dieasPA" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.dieasRad="{item}">
        <slot name="dieasRad" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.injury="{item}">
        <slot name="injury" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.immune="{item}">
        <slot name="immune" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.attachment="{item}">
        <slot name="attachment" v-bind:item="item"></slot>
      </template>
    </v-data-table>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/healthRecord";
export default {
  props: {
    empCode: {
      default: null,
      type: String
    }
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Date",
        value: "dateTaken",
        sortable: false
      },
      {
        text: "Results",
        value: "results",
        sortable: true
      },
      {
        text: "Remarks",
        value: "remarks",
        sortable: true
      },
      {
        text: "Reason",
        value: "reason",
        sortable: true
      },
      {
        text: "Type of Examination",
        value: "examType",
        sortable: false
      },
      {
        text: "Skin",
        value: "skin",
        sortable: false
      },
      {
        text: "Head",
        value: "head",
        sortable: false
      },
      {
        text: "Eyes",
        value: "eyes",
        sortable: false
      },
      {
        text: "Mouth & ENT",
        value: "mouth",
        sortable: false
      },
      {
        text: "Respiratory",
        value: "resp",
        sortable: false
      },
      {
        text: "Heart & Blood Vessels",
        value: "heart",
        sortable: false
      },
      {
        text: "Gastrointestinal",
        value: "gastro",
        sortable: false
      },
      {
        text: "Genito Urinary",
        value: "urinary",
        sortable: false
      },
      {
        text: "Reproductive",
        value: "reprod",
        sortable: false
      },
      {
        text: "Neuromuscular/Skeleal/Joints",
        value: "skeletal",
        sortable: false
      },
      {
        text: "Lymphatic and Circulatory",
        value: "circul",
        sortable: false
      },
      {
        text: "Infectious Diseases",
        value: "infectD",
        sortable: false
      },
      {
        text: "Diseases Due to Noise and Vibration",
        value: "dieasNV",
        sortable: false
      },
      {
        text: "Diseases Due to Hot Temp",
        value: "dieasTHHot",
        sortable: false
      },
      {
        text: "Diseases Due to Cold Temp",
        value: "dieasTHCold",
        sortable: false
      },
      {
        text: "Diseases Due to Pressure",
        value: "dieasPA",
        sortable: false
      },
      {
        text: "Diseases due to Radiation",
        value: "dieasRad",
        sortable: false
      },
      {
        text: "Diseases due to Radiation",
        value: "dieasRad",
        sortable: false
      },
      {
        text: "Accidents/injuries",
        value: "injury",
        sortable: false
      },
      {
        text: "Immunization Program",
        value: "immune",
        sortable: false
      },
      {
        text: "Attachment",
        value: "attachment",
        sortable: false
      }
    ]
  }),
  methods: {
    getByEmpCode(empCode) {
      this.$axios
        .get(`${API_ENDPOINT}/dole/${empCode}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    }
  },
  created() {
    this.getByEmpCode(this.empCode);
  },
  watch: {
    empCode(val) {
      this.getByEmpCode(val);
    }
  }
};
</script>